import React, {useState,useEffect} from 'react';
import {db} from '../firebase/firebaseConfig';
import { ref, update} from "firebase/database";
import {ContenedorFiltros, Contenedor, Formulario, Input, ContenedorDoble, ContenedorSubtitulo, Subtitulo, ContenedorBoton,ContenedorInputconLabel} from './../elementos/ElementosConductores';
import Boton from './../elementos/Boton';
import {ReactComponent as IconoPlus} from './../imagenes/plus.svg';
import Alerta from './../elementos/Alerta'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faIdCard,faPhone,faEnvelope,faUser, faToggleOn,faAddressCard,faPalette,faCar,faCarTunnel,faTrailer, faLocationCrosshairs} from '@fortawesome/free-solid-svg-icons';
import SelectEstadoConductor from './SelectEstadoConductor';
import SelectTipoConductor from './SelectTipoConductor';
import SelectTipoTraking from './SelectTipoTraking';
import SelectCreaViaje from './SelectCreaViaje';

//import { useNavigate } from 'react-router-dom';

const FormularioConductor = ({conductor, CambiarConductor, estadoEditar, CambiarEstadoEditar}) => {
    const [alerta, cambiarAlerta] = useState({});
    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
    const [nombre, cambiarNombre] = useState('');
    const [telefono, cambiarTelefono] = useState('');
    const [correo, cambiarCorreo] = useState('');
    const [rut, cambiarRut] = useState('');
    const [estado, cambiarEstado] = useState('');
    const [id, cambiarId] = useState('');
    const [patente, cambiarPatente] = useState('');
    const [color, cambiarColor] = useState('');
    const [marca, cambiarMarca] = useState('');
    const [modelo, cambiarModelo] = useState('');
    const [tipo, cambiarTipo] = useState('');
    const [numero, cambiarNumero] = useState('');
    const [fotoConductor, cambiarFotoConductor] = useState('');
    const [comentario, cambiarComentario] = useState('');
    const [fotoVehiculo, cambiarFotoVehiculo] = useState('');
    const [tracking, cambiarTracking] = useState('');
    const [tipo_traking, cambiarTipo_traking] = useState('');
    const [crea_traslado, cambiarCrea_traslado] = useState('');
    
    
 //   const navigate = useNavigate();

useEffect (()=>{
    if(conductor.hasOwnProperty("nombre")){cambiarNombre(conductor.nombre)}else{cambiarNombre('')};
    if(conductor.hasOwnProperty("telefono")){cambiarTelefono(conductor.telefono)}else{cambiarTelefono('')};
    if(conductor.hasOwnProperty("correo")){cambiarCorreo(conductor.correo)}else{cambiarCorreo('')};
    if(conductor.hasOwnProperty("rut")){cambiarRut(conductor.rut)}else{cambiarRut('')};    
    if(conductor.hasOwnProperty("estado")){cambiarEstado(conductor.estado)}else{cambiarEstado('')};
    if(conductor.hasOwnProperty("comentario")){cambiarComentario(conductor.comentario)}else{cambiarComentario('')};
    if(conductor.hasOwnProperty("patente")){cambiarPatente(conductor.patente)}else{cambiarPatente('')};
    if(conductor.hasOwnProperty("color")){cambiarColor(conductor.color)}else{cambiarColor('')};
    if(conductor.hasOwnProperty("marca")){cambiarMarca(conductor.marca)}else{cambiarMarca('')};
    if(conductor.hasOwnProperty("modelo")){cambiarModelo(conductor.modelo)}else{cambiarModelo('')};    
    if(conductor.hasOwnProperty("tipo")){cambiarTipo(conductor.tipo)}else{cambiarTipo('')};
    if(conductor.hasOwnProperty("numero")){cambiarNumero(conductor.numero)}else{cambiarNumero('')};
    if(conductor.hasOwnProperty("acepta_traking")){cambiarTracking(conductor.acepta_traking)}else{cambiarTracking('')};
    if(conductor.hasOwnProperty("tipo_traking")){cambiarTipo_traking(conductor.tipo_traking)}else{cambiarTipo_traking('')};
    if(conductor.hasOwnProperty("foto_conductor")){cambiarFotoConductor(conductor.foto_conductor)}else{cambiarFotoConductor('')};
    if(conductor.hasOwnProperty("foto_vehiculo")){cambiarFotoVehiculo(conductor.foto_vehiculo)}else{cambiarFotoVehiculo('')};
    if(conductor.hasOwnProperty("crea_traslado")){cambiarCrea_traslado(conductor.crea_traslado)}else{cambiarCrea_traslado('')};
    cambiarId(conductor.id);
},[conductor])

const StyleFotoConductor={
    backgroundImage: 'url('+fotoConductor+')',
    height:'200px',
    width: '200px',
    marginTop:'20px',
    backgroundSize: 'cover',
    borderRadius: '100px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
};

const StyleFotoVehiculo={
    backgroundImage: 'url('+fotoVehiculo+')',
    height:'200px',
    width: '200px',
    marginTop:'20px',
    backgroundSize: 'cover',
    borderRadius: '100px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
    
};

const handleChange = (e) => {
    if(e.target.name === 'nombre'){
        cambiarNombre(e.target.value);
    } else if (e.target.name === 'telefono'){
        cambiarTelefono(e.target.value);
    } else if (e.target.name === 'correo'){
        cambiarCorreo(e.target.value);
    } else if (e.target.name === 'rut'){
        cambiarRut(e.target.value);
    } else if (e.target.name === 'estado'){
        cambiarEstado(e.target.value);
    } else if (e.target.name === 'comentario'){
        //cambiarCorreo(e.target.value);
    } else if (e.target.name === 'patente'){
        cambiarPatente(e.target.value);
    } else if (e.target.name === 'color'){
        cambiarColor(e.target.value);
    } else if (e.target.name === 'marca'){
        cambiarMarca(e.target.value);
    } else if (e.target.name === 'modelo'){
        cambiarModelo(e.target.value);
    } else if (e.target.name === 'tipo'){
        cambiarTipo(e.target.value);
    } else if (e.target.name === 'numero'){
        cambiarNumero(e.target.value);
    }else if (e.target.name === 'tipo_traking'){
        cambiarTipo_traking(e.target.value);
    }else if (e.target.name === 'crea_traslado'){
        cambiarCrea_traslado(e.target.value);
    }    
}

const handleSubmit = async (e) => {
    e.preventDefault();
  update(ref(db,'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/conductores/'+id),
  { nombre: nombre,
    telefono: telefono,
    rut: rut,
    estado: estado,
    patente: patente,
    color: color,
    marca: marca,
    modelo: modelo,
    tipo: tipo,
    comentario: comentario,
    numero: numero,
    tipo_traking: tipo_traking,
    crea_traslado: crea_traslado
  })
  cambiarEstadoAlerta(true);
                cambiarAlerta({
                    tipo: 'exito',
                    mensaje: 'Datos actualizados con Exito'
                });
    CambiarConductor({});
    setTimeout(() => window.location.reload(true), 1000)

}

    return (  
        <Formulario onSubmit={handleSubmit}>
            <Contenedor>
            <div hidden={estadoEditar}>
            <ContenedorDoble>
                <main>
                <ContenedorSubtitulo><Subtitulo>Informacion del Conductor</Subtitulo></ContenedorSubtitulo>    
               
            {/* Campos de Conductor}*/}
            <ContenedorInputconLabel><p>Estado</p><SelectEstadoConductor estado={estado} cambiarEstado={cambiarEstado}/></ContenedorInputconLabel>
            <ContenedorInputconLabel><p>Nombre</p><Input name="nombre" type="text" placeholder="Nombre" value={nombre} onChange={handleChange}/></ContenedorInputconLabel>    
            <ContenedorInputconLabel><p>Telefono</p><Input name="telefono" type="text" placeholder="Telefono" value={telefono} onChange={handleChange} /></ContenedorInputconLabel>   
            <ContenedorInputconLabel><p>E-mail</p><Input name="correo" type="text" placeholder="E-mail"  value={correo} onChange={handleChange} disabled = {true}/></ContenedorInputconLabel>
            <ContenedorInputconLabel><p>RUT</p><Input name="rut" type="text" placeholder="RUT" value={rut} onChange={handleChange} /></ContenedorInputconLabel>
            <ContenedorInputconLabel><p>Comienza Traking</p><SelectTipoTraking tipo_traking={tipo_traking} cambiarTipo_traking={cambiarTipo_traking}/></ContenedorInputconLabel>
            <ContenedorInputconLabel><p>ID</p><Input name="id" type="text" placeholder="RUT" value={id} onChange={handleChange} /></ContenedorInputconLabel>
            
                <ContenedorBoton><p>Foto Conductor</p><div style={StyleFotoConductor}/></ContenedorBoton>
            </main>

            <aside>
            <ContenedorSubtitulo><Subtitulo>Informacion del Vehiculo</Subtitulo></ContenedorSubtitulo>   
            {/* Campos del Vehiculo*/}
            <ContenedorInputconLabel><p>Crea Viaje</p><SelectCreaViaje crea_traslado={crea_traslado} cambiarCrea_traslado={cambiarCrea_traslado}/></ContenedorInputconLabel>
            <ContenedorInputconLabel><p>Patente</p><Input name="patente" type="text" placeholder="Patente" value={patente} onChange={handleChange} /></ContenedorInputconLabel>    
            <ContenedorInputconLabel><p>Color</p><Input name="color" type="text" placeholder="Color" value={color} onChange={handleChange} /></ContenedorInputconLabel>   
            <ContenedorInputconLabel><p>Marca</p><Input name="marca" type="text" placeholder="Marca" value={marca} onChange={handleChange} /></ContenedorInputconLabel>
            <ContenedorInputconLabel><p>Modelo</p><Input name="modelo" type="text" placeholder="Modelo"value={modelo} onChange={handleChange} /></ContenedorInputconLabel>      
            <ContenedorInputconLabel><p>Tipo Vehiculo</p><SelectTipoConductor tipo={tipo} cambiarTipo={cambiarTipo}/></ContenedorInputconLabel>
            <ContenedorInputconLabel><p>Acepta Tracking</p><Input name="tracking" type="text" placeholder="Sin Datos"  value={tracking} onChange={handleChange} disabled = {true}/></ContenedorInputconLabel>
                <ContenedorBoton><p>Foto Vehiculo</p><div style={StyleFotoVehiculo}/></ContenedorBoton>
                </aside>
            </ContenedorDoble>
            {/* Boton Guardar Edicion}*/}
            <ContenedorBoton >
                        <Boton as="button" primario conIcono onClick={handleSubmit}> Guardar &nbsp;&nbsp;<IconoPlus/></Boton>
                </ContenedorBoton> 
            </div>
            </Contenedor>

            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                cambiarEstadoAlerta={cambiarEstadoAlerta}
            />
        </Formulario>
    );
}

export default FormularioConductor;